import { format } from 'date-fns'

export function formatDate(created_at) {
  return format(new Date(created_at), 'MMM d')
}

export function formatYear(created_at) {
  return format(new Date(created_at), 'yyyy')
}
